module.exports = __webpack_public_path__ + "img/pasc.e452aea7.svg";